<div class="modal-layer">
    <div class="backdrop"></div>
    <div class="mdl"></div>
</div>


<div class="content-title">
    <span *ngIf="loaded">{{ member.user }}</span>
    <span *ngIf="!loaded">Събиране на данни...</span>
</div>
<div class="sub-title">
    <i class="action-left icon arrow-left" (click)="prevMonth()"></i>
    <span>{{ returnMonthName(returnMonth(datePicker)) }} {{ returnYear(datePicker) }}</span>
    <i class="action-right icon arrow-right" (click)="nextMonth()"></i>
</div>
<div class="timetable-hdr">
    <div class="primary">Персонал</div>
    <div class="hours">
        <span>00:00</span>
        <span>03:00</span>
        <span>06:00</span>
        <span>09:00</span>
        <span>12:00</span>
        <span>15:00</span>
        <span>18:00</span>
        <span>21:00</span>
    </div>
</div>
<div class="timetable-body">
    <div class="loading" *ngIf="loading_data">
        <span>СЪБИРАНЕ НА ДАННИ...</span>
    </div>
    <div class='timeline-row' *ngFor="let dt of current_purchase_month_dates">
        <span class="name">{{ dt.formal_date }}</span>
        <div class="line">
            <div class="fill" *ngFor="let segment of dt.segments" [ngClass]="{ 'hidden':segment.start_hour == undefined || segment.end_hour == undefined || segment.end_hour == '' }" [ngStyle]="{ 'width':segment.width + '%', 'left':segment.start_offset + '%' }">
                <span *ngIf="segment.start_hour != '' && segment.end_hour != ''">{{ segment.start_hour }} - {{ segment.end_hour }} </span>
            </div>
        </div>
    </div>
</div>